import { ChangeColor } from './ChangeColor';

export class ChangeLinkOnGreyColor extends ChangeColor {
  type: string = 'ChangeLinkOnGreyColor';
}
